"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Hashing = void 0;
const hashing_1 = require("../../crypto/hashing");
const strings_1 = require("../../util/strings");
const Serialization_1 = require("./Serialization");
class Hashing {
    static forString(text, seed) {
        if (seed === undefined) {
            seed = '';
        }
        let firstPass = Hashing.sha.sha256base64('0a' + text + seed);
        let secondPass = Hashing.rmd.rmd160base64(text + firstPass);
        return secondPass;
    }
    static forValue(value, seed) {
        let text = Serialization_1.Serialization.default(value);
        return Hashing.forString(text, seed);
    }
    static toHex(hash) {
        return strings_1.Strings.base64toHex(hash);
    }
    static fromHex(hex) {
        return strings_1.Strings.hexToBase64(hex);
    }
}
exports.Hashing = Hashing;
Hashing.sha = new hashing_1.SHAImpl();
Hashing.rmd = new hashing_1.RMDImpl();
//# sourceMappingURL=Hashing.js.map